export enum sortFilterType {
  sortprice_asc = 'sortprice_asc',
  sortprice_desc = 'sortprice_desc',
  sortname_asc = 'sortname_asc',
  sortname_desc = 'sortname_desc',
  sortsize_asc = 'sortsize_asc',
  sortsize_desc = 'sortsize_desc',
  sortamount_asc = 'sortamount_asc',
  sortamount_desc = 'sortamount_desc',
  sortdate_asc = 'sortdate_asc',
  sortdate_desc = 'sortdate_desc'
};